import { render, staticRenderFns } from "./DisqualificationDestoryApply.vue?vue&type=template&id=71a2fab9"
import script from "./DisqualificationDestoryApply.vue?vue&type=script&lang=js"
export * from "./DisqualificationDestoryApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports